import {
  ReceptionistDashboardTopBarActions,
  ReceptionistDashboardView,
  type ReceptionistDemoState,
} from '@elva/ui';
import { useState } from 'react';
import { usePageTopBar } from '@/app/layouts/pageTopBar';

export function DashboardPage() {
  const [demoState, setDemoState] = useState<ReceptionistDemoState>('mature');

  usePageTopBar({
    actions: (
      <ReceptionistDashboardTopBarActions demoState={demoState} onDemoStateChange={setDemoState} />
    ),
    actionsVersion: demoState,
  });

  return <ReceptionistDashboardView demoState={demoState} />;
}
